module.exports = __webpack_public_path__ + "img/03-trpg-material2021.8932053b.png";